package com.wintermar.inspection.feature.presentation.inspection.answer.widget.content_item_button

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.component.button.Button
import com.wintermar.inspection.core.ui.component.button.variant.ButtonVariant
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.feature.domain.model.answer.AnswerModel
import com.wintermar.inspection.graphql.type.InspectionAnswerType
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.category
import inspection.composeapp.generated.resources.files
import inspection.composeapp.generated.resources.ic_attachment
import inspection.composeapp.generated.resources.ic_image
import inspection.composeapp.generated.resources.ic_notes
import inspection.composeapp.generated.resources.ic_task
import inspection.composeapp.generated.resources.notes
import inspection.composeapp.generated.resources.photos
import org.jetbrains.compose.resources.stringResource

@Composable
fun ContentItemButtonView(
    answer: AnswerModel,
    answerType: InspectionAnswerType,
    fillWidthButton: Boolean,
    dimension: AppDimension = LocalAppTheme.current.dimension,
    onShowModalNotes: () -> Unit,
    onShowModalFiles: () -> Unit,
    onShowFindingCategory: () -> Unit
) {
    AnimatedVisibility(
        visible = (answer.notes.isEmpty() || answer.files.isEmpty()) && answerType != InspectionAnswerType.USER_ID,
        enter = fadeIn(),
        exit = fadeOut()
    ) {
        Row(
            modifier = if (fillWidthButton) Modifier.fillMaxWidth() else Modifier,
            horizontalArrangement = Arrangement.spacedBy(
                dimension.spacing.space2
            ),
            verticalAlignment = Alignment.CenterVertically
        ) {
            if (answer.notes.isEmpty()) {
                Button(
                    buttonVariant = ButtonVariant.MediumSecondary,
                    leadingIcon = Res.drawable.ic_notes,
                    text = stringResource(Res.string.notes),
                    mandatory = answer.isEmptyFileAndNotes(),
                    modifier = if (fillWidthButton) Modifier.weight(1f) else Modifier,
                    onClick = {
                        onShowModalNotes()
                    }
                )
            }

            if (answer.files.isEmpty()) {
                Button(
                    buttonVariant = ButtonVariant.MediumSecondary,
                    leadingIcon = Res.drawable.ic_attachment,
                    text = stringResource(Res.string.files),
                    mandatory = answer.isEmptyFileAndNotes(),
                    modifier = if (fillWidthButton) Modifier.weight(1f) else Modifier,
                    onClick = {
                        onShowModalFiles()
                    }
                )
            }
        }
    }

    AnimatedVisibility(
        visible = answer.isEmptyFindingCategory() && answerType != InspectionAnswerType.USER_ID,
        enter = fadeIn(),
        exit = fadeOut()
    ) {
        Button(
            buttonVariant = ButtonVariant.MediumSecondary,
            leadingIcon = Res.drawable.ic_task,
            text = stringResource(Res.string.category),
            mandatory = answer.isEmptyFindingCategory(),
            modifier = if (fillWidthButton) Modifier.fillMaxWidth() else Modifier,
            onClick = {
                onShowFindingCategory()
            }
        )
    }
}
